// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"2c41d653","52":"f0fbfb5a","210":"8a590a0f","707":"6a8b113a","723":"dcabc9f0","791":"4c634ff9"}[chunkId] + ".chunk.css";
};